import styled from 'styled-components';

import {
  BodyStandardRegular,
  BodyXSmallRegular,
  Colour,
  HeadingSmallMedium,
} from '@xemplo/style-constants';

export const PromptBody = styled.div`
  text-align: center;
  margin-inline: auto;
  color: ${Colour.Gray[600]};
  ${BodyStandardRegular};
`;

export const PromptHeader = styled.div`
  display: flex;
  margin: 40px 40px 0 40px;
  align-items: center;
  flex-direction: column;
  text-align: center;
  gap: 12px;
  & > svg {
    height: 48px;
    width: 48px;
    color: ${Colour.Blue[400]};
  }
`;

export const PromptHeaderTitle = styled.div`
  color: ${Colour.Gray[500]};
  ${HeadingSmallMedium};
`;

export const ErrorMessage = styled.div`
  display: flex;
  padding: 8px;
  margin-top: 16px;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  border: 1px solid ${Colour.Red[300]};
  background: ${Colour.Red[50]};
  color: ${Colour.Gray[600]};
  justify-content: flex-start;
  ${BodyXSmallRegular};
  & > svg {
    color: ${Colour.Red[500]};
    height: 24px;
    width: 24px;
  }
`;
